import {BaseElement} from "../../../interfaces/BaseElement";
import {MultipleSelector} from "../../../interfaces/MultipleSelector";
import {isMobile} from "../../../../settings";

export class ActiveFiltersCounter {
    #rootElement;

    constructor() {
        this.#rootElement = new BaseElement()
            .addClass('search__filter-counter', 'search__filter-counter--active', 'hidden')
            .innerHtml(0);
        this.amountOfActiveFilters = 0;
    }

    update() {
        if (this.#isAnyHiddenFilterActive()) {
            this.#rootElement.removeClass('hidden');
            // this.#rootElement.addClass('search__filter-counter--active');
        } else {
            this.#rootElement.addClass('hidden');
            // this.#rootElement.removeClass('search__filter-counter--active');
        }

    }

    get rootElement() {
        return this.#rootElement;
    }

    remove() {
        this.#rootElement.remove();
        this.#rootElement = null;
    }

    #isAnyHiddenFilterActive() {
        this.amountOfActiveFilters = 0;
        if (isMobile) {
            const activeFiltersAmount = document.querySelectorAll('.mobile-search__filter-pop-up .search__option[state="active"]').length;
            this.amountOfActiveFilters += activeFiltersAmount;
        } else {
            const hiddenActiveFiltersAmount = document.querySelectorAll('.search__top-wrapper .search__option.hidden[state="active"]').length;
            this.amountOfActiveFilters += hiddenActiveFiltersAmount;
        }

        if (MultipleSelector.scopes['multipleSearch']?.selected.size > 0)
            this.amountOfActiveFilters++;

        this.#rootElement.innerHtml(this.amountOfActiveFilters);

        return this.amountOfActiveFilters > 0;
    }
}
